import { RevisionType } from '@common/services/revision';

export const REVISION_TYPE_TEXTS: Record<RevisionType, string> = {
  [RevisionType.ADD]: 'Ajout',
  [RevisionType.MOD]: 'Modification',
  [RevisionType.DEL]: 'Suppression',
};